import { VideoPlayer } from "@/components/ui/video-player";
import { t } from "@/lib/typography";

interface BookIntroVideoProps {
  src: string;
  title: string;
}

export function BookIntroVideo({ src, title }: BookIntroVideoProps) {
  return (
    <div className="space-y-2">
      <h2 className={t.sectionTitle}>Introduction</h2>
      <VideoPlayer src={src} title={`${title} — Introduction`} />
    </div>
  );
}
